// components/Common/PlaceholderDuctHint.jsx
import React from "react";
import { DUMMY_DUCTS } from "../../builders/dummyDucts";
import "./PlaceholderDuctHint.css";

/**
 * Yellow hint shown when a scenario uses placeholder ducts.
 * Props: enclosure, sections (booleans from usePlaceholderDucts), children (optional extra line)
 */
const PlaceholderDuctHint = ({ enclosure, sections, children }) => {
  if (!enclosure && !sections) return null;

  return (
    <div className="duct-hint" role="status">
      <strong>No duct selected – placeholder ducts are used.</strong>
      <ul>
        {enclosure && (
          <li>
            Enclosure ducts: {DUMMY_DUCTS.enclosure.width}×{DUMMY_DUCTS.enclosure.depth} mm
          </li>
        )}
        {sections && (
          <li>
            Section ducts: {DUMMY_DUCTS.sections.width}×{DUMMY_DUCTS.sections.depth} mm
          </li>
        )}
      </ul>
      {children ?? "Select real ducts before exporting."}
    </div>
  );
};

export default PlaceholderDuctHint;
